// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopExpandable_root__Bwcds","header":"WebshopExpandable_header__-NYeM","content":"WebshopExpandable_content__2DYOx"};